interface SectionLabelProps {
  children: React.ReactNode;
  variant?: 'section' | 'eyebrow';
}

/** Small letterspaced caps label, echoing the tagline rule in the logo. */
export function SectionLabel({ children, variant = 'section' }: SectionLabelProps) {
  return <p className={variant === 'eyebrow' ? 'eyebrow' : 'section-label'}>{children}</p>;
}
